import React from 'react';
import './Skeleton.css';

const Skeleton = ({ variant = 'text', width, height, className = '', children, ...props }) => {
  const baseClasses = 'skeleton';
  const variantClasses = {
    text: 'skeleton-text',
    avatar: 'skeleton-avatar',
    button: 'skeleton-button',
    badge: 'skeleton-badge',
    card: 'skeleton-card'
  };

  const classes = [baseClasses, variantClasses[variant] || '', className].filter(Boolean).join(' ');

  const style = {
    width: width || undefined,
    height: height || undefined,
    ...props.style
  };

  return (
    <div className={classes} style={style} role="status" aria-label="Loading content" {...props}>
      {children}
    </div>
  );
};

export default Skeleton;
